import axios from '../../axios';

import { formatDate } from '../../helpers/date';
import { getQueryNameByRelationType } from '../../helpers/relation';

import { REDUCERS } from '../../constants/reducers';

import { EventService } from '../../services';

export const setCurrentEvent = value => ({
  type: REDUCERS.EVENT.SET_CURRENT_EVENT,
  value
});

export const setFilteredEvents = value => ({
  type: REDUCERS.EVENT.SET_FILTERED_EVENTS,
  value
});

export const setEventQueryParams = value => ({
  type: REDUCERS.EVENT.SET_EVENT_QUERY_PARAMS,
  value
});

export const setEventList = value => ({
  type: REDUCERS.EVENT.SET_EVENT_LIST,
  value
});

export const setEventsForNextThreeDays = value => ({
  type: REDUCERS.EVENT.SET_EVENTS_FOR_NEXT_THREE_DAYS,
  value
});

export const setEventState = value => ({
  type: REDUCERS.EVENT.SET_EVENT_STATE,
  value
});

export const getEventsForNextThreeDays = params => {
  return async dispatch => {
    try {
      const { data } = await EventService.getAllEvents(params);
      dispatch(setEventsForNextThreeDays(data));
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const getAllEvents = params => {
  return async dispatch => {
    try {
      const { data } = await EventService.getAllEvents(params);
      dispatch(setEventList(data));
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const getEventById = id => {
  return async dispatch => {
    try {
      const { data } = await EventService.getEventById(id);
      const event = {
        ...data,
        relationType: data.relationType ?? null,
        remindDate: formatDate(data.remind_at),
        startDate: formatDate(data.start_at),
        endDate: formatDate(data.end_at),
        userIds: data.users?.map(user => user.id),
        userEmails: data.users?.map(user => user.email)
      };
      dispatch(setCurrentEvent(event));
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const createNewEvent = payload => {
  return async () => {
    try {
      const { data } = await EventService.createNewEvent(payload);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const updateEvent = (id, payload) => {
  return async (dispatch, getState) => {
    try {
      const { data } = await EventService.updateEvent(id, payload);
      await getAllEvents();

      // const { events } = getState().event;
      //
      // const idx = events.findIndex(event => event.id === id);
      //
      // const newEvents = [...events];
      // newEvents.splice(idx, 1, data);
      //
      // dispatch(setEventList(newEvents));

      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const deleteEvent = (id, queryParams) => {
  return async dispatch => {
    try {
      const { data } = await EventService.deleteEvent(id, queryParams);
      dispatch(setCurrentEvent({}));
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const sendRelationQuery = relationType => {
  return async () => {
    try {
      const queryName = getQueryNameByRelationType(relationType);
      let response = await axios.get(queryName);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const acceptEvent = id => {
  return async () => {
    try {
      const { data } = await EventService.acceptEvent(id);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const declineEvent = id => {
  return async () => {
    try {
      const { data } = await EventService.declineEvent(id);
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};
